import { w as win } from "./common-namespaces-client-C7k75bsz.mjs";
const otto = win.otto ?? {};
export {
  otto as o
};
/*                                                     */
